import { OnboardingData } from './types'
import { createUser, sendVerification } from '../../../utils/Firebase/methods'
import http from '../../../utils/Http/Http'
import { getUserData } from '../../../api/user/useFetchUser'
import getUserMetrics from '../../../api/user/getUserMetrics'
import { createCheckoutSession } from '../../../api/stripe/createCheckoutSession'
import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit'
import { UserDataPayload } from '../../../api/user/types'
import { updateUser } from '../../../api/user/editUser'
import { createPropLead, CreatePropLeadParams } from '../../../api/crm/createPropLead'

export const createAppUser = async (payload: OnboardingData & { setup_intent_id?: string }) => {
	const firebaseUser = await createUser({
		email: payload.email,
		password: payload.password,
		firstName: payload.firstName,
		lastName: payload.lastName,
	})

	await http({
		url: '/user',
		method: 'post',
		data: {
			firstName: payload.firstName,
			lastName: payload.lastName,
			phone_number: payload.phoneNumber,
			email: payload.email,
			user_id: firebaseUser.user.uid,
			company_name: payload.companyName,
			onboarding_flow: true,
			setup_intent_id: payload.setup_intent_id,
		},
	})

	await sendVerification()
}

export const fetchUserData = async (uid: string) => {
	return getUserData(uid, true)
}

export const fetchUserMetrics = (startDate: string) => {
	return getUserMetrics(startDate)
}

export const editUserData = async (userDataPayload: UserDataPayload) => {
	await updateUser(userDataPayload)
	return await fetchUserData(userDataPayload.user_id as string)
}

export const createStripeCustomerSession: AsyncThunkPayloadCreator<
	any,
	{
		email: string
		phoneNumber: string
	}
> = async (payload) => {
	const data = await createCheckoutSession(
		payload.phoneNumber,
		payload.email,
		process.env.REACT_APP_STRIPE_DEFAULT_PRODUCT_ID || '',
	)
	sessionStorage.setItem('stripe_client_secret', data.client_secret)
	sessionStorage.setItem('stripe_setup_intent_id', data.setup_intent_id)
	return data
}

export const createCrmContact: AsyncThunkPayloadCreator<any, CreatePropLeadParams> = async (payload) => {
	const data = await createPropLead(payload)
	return data
}
